import React, { useState } from 'react'
import { CFooter, CContainer, CCol, CCardBody, CCardText, CImage } from '@coreui/react'
import PropTypes from 'prop-types'
import CIcon from '@coreui/icons-react'
import logo from 'src/assets/images/ER_horizontal_blanco.png'
import { AppOrganismo, Autoridades } from '../components/index'
import {
  cilLocationPin,
  cibFacebookF,
  cibInstagram,
  cibYoutube,
  cibTwitter,
  cilPhone,
} from '@coreui/icons'
import { useLocation } from 'react-router-dom'

const AppFooter = (props) => {
  const { sitio, home } = props
  const [loading, setLoading] = useState(true)
  const [size, setSize] = useState(window.innerWidth)
  const basePath = String(process.env.PUBLIC_URL).trim()
  const location = useLocation()

  const noticia =
    location.pathname.includes('/noticias') && !location.pathname.includes('/buscador')

  const cambio = () => {
    setSize(window.innerWidth)
  }

  if (loading) {
    setLoading(false)
    window.addEventListener('resize', cambio)
  }

  return (
    <>
      <CFooter style={{ padding: '0px', lineHeight: 2 }}>
        {noticia && sitio === '0' && (
          <div className="autoridades w-100" style={{ minHeight: '3rem' }}>
            <CContainer fluid className="container-er container-autoridades-noticias">
              <b className="centrar">Secretaría de Comunicación y Prensa</b>
              <div>
                <a
                  href="https://portal.entrerios.gov.ar/comunicacion"
                  target="_self"
                  rel="noreferrer"
                  aria-label="Sitio web de la Secretaría de Comunicación"
                >
                  https://portal.entrerios.gov.ar/comunicacion
                </a>
                <p>seccomunicacion@entrerios.gov.ar</p>
              </div>
            </CContainer>
          </div>
        )}

        {sitio !== '0' && (home ? <Autoridades sitio={sitio} /> : <AppOrganismo sitio={sitio} />)}
        <CContainer fluid className="container-er centrar" style={{ minHeight: '16rem' }}>
          <CCol className="mb-4" xs={12} sm={12} md={8}>
            <CCardBody style={{ paddingLeft: '0' }}>
              <CCardText className="texto-pie">CASA DE GOBIERNO</CCardText>
              <CCardText className="texto-pie">
                <CIcon icon={cilPhone} size="xl" style={{ transform: 'rotate(105deg)' }} />
                <a className="t-u-numero-blanco texto-pie" href="tel:0800-555-8500">
                  0800-555-8500
                </a>
                &nbsp;- Lunes a Viernes: 7:00 a 19:00
              </CCardText>
              <CCardText className="texto-pie">
                <CIcon icon={cilLocationPin} size="xl" />
                Gregorio Fernández de la Puente 220 - Paraná
              </CCardText>
            </CCardBody>
          </CCol>
          {size >= 768 ? (
            <CCol xs={12} sm={12} md={4} className="d-flex pie-logo centrar flex-end">
              <a href={basePath + '/'}>
                <CImage className="sidebar-brand-full" src={logo} height={70} />
              </a>
            </CCol>
          ) : (
            <CCol xs={12} sm={12} md={4} className="logo-header-redes-c mb-4">
              <a
                href="https://www.facebook.com/GobiernoER"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook Gobierno Entre Ríos"
              >
                <CIcon
                  icon={cibFacebookF}
                  style={{ marginRight: '0.50rem', color: '#FFF' }}
                  height={20}
                ></CIcon>
              </a>
              <a
                href="https://www.youtube.com/c/GobiernoER"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube Gobierno Entre Ríos"
              >
                <CIcon
                  icon={cibYoutube}
                  style={{ marginRight: '0.50rem', color: '#FFF' }}
                  height={20}
                ></CIcon>
              </a>
              <a
                href="https://twitter.com/GobiernoER"
                target="_blank"
                rel="noreferrer"
                aria-label="Twitter Gobierno Entre Ríos"
              >
                <CIcon
                  icon={cibTwitter}
                  style={{ marginRight: '0.50rem', color: '#FFF' }}
                  height={20}
                ></CIcon>
              </a>
              <a
                href="https://instagram.com/gobiernoer?igshid=YmMyMTA2M2Y="
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram Gobierno Entre Ríos"
              >
                <CIcon icon={cibInstagram} style={{ color: '#FFF' }} height={20}></CIcon>
              </a>
            </CCol>
          )}
        </CContainer>
      </CFooter>
      <CCol xs={12} md={12} lg={12}>
        <div className="socalo">Desarrollo: Dirección General de Informática</div>
      </CCol>
    </>
  )
}

AppFooter.propTypes = {
  sitio: PropTypes.string,
  home: PropTypes.bool,
}

export default React.memo(AppFooter)
